import CollectingOpeningSoonPhoneNumberPage from "@faire/prototype-playground/workspace/tc/collecting-opening-soon-phone-number";
import FirstOrderIncentiveTieringPage from "@faire/prototype-playground/workspace/tc/first-order-incentive-tiering";
import MagicSignupFromEmailDomainPage from "@faire/prototype-playground/workspace/tc/magic-signup";
import PersonalizedClickableFoiBannerPage from "@faire/prototype-playground/workspace/tc/personalized-clickable-foi-banner";
import WelcomePageBrandMatchesPage from "@faire/prototype-playground/workspace/tc/welcome-brand-matches";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import NuxCategorySelectorPage from "../../pages/NuxCategorySelector";

const RevampedFdSignupPage = lazy(
  () => import("../../workspace/tc/revamped-fd-signup/Page")
);

export function TonyChenRoutes() {
  return (
    <Switch>
      <Route
        path="/tc/collecting-opening-soon-phone-number"
        component={CollectingOpeningSoonPhoneNumberPage}
      />
      <Route
        path="/tc/first-order-incentive-tiering"
        component={FirstOrderIncentiveTieringPage}
      />
      <Route
        path="/tc/magic-signup"
        component={MagicSignupFromEmailDomainPage}
      />
      <Route
        path="/tc/nux-category-selector"
        component={NuxCategorySelectorPage}
      />
      <Route
        path="/tc/personalized-clickable-foi-banner"
        component={PersonalizedClickableFoiBannerPage}
      />
      <Route
        path="/tc/revamped-fd-signup"
        component={RevampedFdSignupPage}
      />
      <Route
        path="/tc/welcome-brand-matches"
        component={WelcomePageBrandMatchesPage}
      />
    </Switch>
  );
}

export const slug = "tc";
